import { render, staticRenderFns } from "./YourPlan.vue?vue&type=template&id=55a3ec64&scoped=true&lang=pug&"
import script from "./YourPlan.vue?vue&type=script&lang=js&"
export * from "./YourPlan.vue?vue&type=script&lang=js&"
import style0 from "./YourPlan.vue?vue&type=style&index=0&id=55a3ec64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3ec64",
  null
  
)

export default component.exports